import type {
  CollectionNode,
  PageContent,
  ServerPageContent,
} from "src/types/collection/collectionTypes";

/** 서버 응답(ServerPageContent) → UI 표준(PageContent) */
export const normalizeCollectionPage = (
  raw: ServerPageContent<CollectionNode>
): PageContent<CollectionNode> => {
  return {
    content: raw?.content ?? [],
    page: raw?.page?.number ?? 0,
    size: raw?.page?.size ?? 20,
    totalElements: raw?.page?.totalElements ?? 0,
    totalPages: raw?.page?.totalPages ?? 1,
  };
};
